// CheckboxControlView
import eventBus         from 'EventBus';
import BaseControlView from 'BaseControlView';
import constants        from "Constants";
import template from 'common-inputs/control_checkbox.ejs';

//=====================================================================
//
// An instance of this view represents a checkbox control.
//
// Maty Rocha, February, 11 2016
//
//=====================================================================
class CheckboxControlView extends BaseControlView  {

    initialize( opts ) {
        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_COMMON_INPUTS;
        this.icon = 'pf-checkbox';
        this.propViews = opts.propViews;

        if (!this.model.get('name')) {
            this.model.set('name', 'Name', {silent: true});
        }

        if (!this.model.get('value')) {
            this.model.set('value', 'Value', {silent: true});
        }

        if (!this.model.get('label')) {
            this.model.set('label', 'Checkbox', {silent: true});
        }

        if (!this.model.get('isSelected')) {
            this.model.set('isSelected', false, {silent: true});
        }

        this.listenTo( eventBus, 'CheckboxThemeChange', this.themeChangeRender);

        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);

        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'CheckboxControlView'
    get kind() {
        return 'CheckboxControlView';
    }


}

export default CheckboxControlView;

